import { entityDialogShowsCreateHeader, type EntityDialogOperation, type EntityDialogPresentation } from './entity.dialog.contracts';

/**
 * Who draws a dialog's title bar. `host` = this dialog, `surface` = the mounted surface (its type owns
 * dialog chrome, so capability controls can sit beside close), `none` = nobody (edit, pseudo-page,
 * `chrome: 'none'`).
 */
export type EntityDialogChrome = 'host' | 'surface' | 'none';

export interface EntityDialogBody {
  readonly kind: 'surface' | 'custom';
  /** The surface type declares `ownsDialogChrome` (only Form today). Ignored for custom bodies. */
  readonly surfaceOwnsChrome: boolean;
}

/** The existing create-header rule decides whether there is a title bar; the body decides who draws it. */
export function resolveEntityDialogChrome(operation: EntityDialogOperation, presentation: EntityDialogPresentation | undefined, body: EntityDialogBody): EntityDialogChrome {

  if (!entityDialogShowsCreateHeader(operation, presentation)) return 'none';
  return body.kind === 'surface' && body.surfaceOwnsChrome ? 'surface' : 'host';
}
